import { SVGProps, Ref, forwardRef, useId } from 'react';

export const MaxSquareBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <mask
                    id={`${_uniqueId}mask0_15053_903`}
                    style={{
                        maskType: 'alpha',
                    }}
                    maskUnits="userSpaceOnUse"
                    x={1}
                    y={1}
                    width={22}
                    height={22}
                    suppressHydrationWarning
                >
                    <rect
                        x={1}
                        y={1}
                        width={22}
                        height={22}
                        rx={4.583}
                        fill={`url(#${_uniqueId}paint0_linear_15053_903)`}
                        suppressHydrationWarning
                    />
                </mask>
                <g mask={`url(#${_uniqueId}mask0_15053_903)`} suppressHydrationWarning>
                    <rect x={1} y={1} width={22} height={22} fill="white" />
                    <g filter={`url(#${_uniqueId}filter0_f_15053_903)`} suppressHydrationWarning>
                        <circle cx={9.25} cy={10.167} r={14.667} fill="#2A40F1" />
                    </g>
                    <g filter={`url(#${_uniqueId}filter1_f_15053_903)`} suppressHydrationWarning>
                        <circle cx={25.75} cy={-1.75} r={14.667} fill="#8950E1" />
                    </g>
                    <g filter={`url(#${_uniqueId}filter2_f_15053_903)`} suppressHydrationWarning>
                        <circle cx={0.083} cy={26.667} r={14.667} fill="#4AC1FC" />
                    </g>
                    <g filter={`url(#${_uniqueId}filter3_f_15053_903)`} suppressHydrationWarning>
                        <circle cx={26.667} cy={23} r={14.667} fill="#A261DF" />
                    </g>
                </g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.158 19.292c-1.447 0-2.12-.212-3.288-1.056-.74.95-3.08 1.692-3.183.422 0-.953-.21-1.758-.45-2.638-.285-1.083-.61-2.29-.61-4.037 0-4.175 3.43-7.316 7.493-7.316 4.066 0 7.252 3.295 7.252 7.354a7.24 7.24 0 0 1-2.102 5.126 7.26 7.26 0 0 1-5.112 2.145m.06-11.017c-1.978-.102-3.52 1.267-3.862 3.412-.282 1.776.218 3.94.644 4.052.205.05.719-.366 1.039-.686.53.366 1.147.585 1.788.637a3.77 3.77 0 0 0 3.94-3.507 3.76 3.76 0 0 0-3.549-3.904z"
                    fill="white"
                />
            </g>
            <defs>
                <filter
                    id={`${_uniqueId}filter0_f_15053_903`}
                    x={-16.692}
                    y={-15.775}
                    width={51.883}
                    height={51.883}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={5.638} result="effect1_foregroundBlur_15053_903" />
                </filter>
                <filter
                    id={`${_uniqueId}filter1_f_15053_903`}
                    x={-0.192}
                    y={-27.692}
                    width={51.883}
                    height={51.883}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={5.638} result="effect1_foregroundBlur_15053_903" />
                </filter>
                <filter
                    id={`${_uniqueId}filter2_f_15053_903`}
                    x={-25.858}
                    y={0.725}
                    width={51.883}
                    height={51.883}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={5.638} result="effect1_foregroundBlur_15053_903" />
                </filter>
                <filter
                    id={`${_uniqueId}filter3_f_15053_903`}
                    x={0.725}
                    y={-2.942}
                    width={51.883}
                    height={51.883}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                    suppressHydrationWarning
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation={5.638} result="effect1_foregroundBlur_15053_903" />
                </filter>
                <linearGradient
                    id={`${_uniqueId}paint0_linear_15053_903`}
                    x1={6.5}
                    y1={5.583}
                    x2={23}
                    y2={12}
                    gradientUnits="userSpaceOnUse"
                    suppressHydrationWarning
                >
                    <stop stopColor="#2242F7" />
                    <stop offset={1} stopColor="#A35EDE" />
                </linearGradient>
            </defs>
        </svg>
    );
});
MaxSquareBrandSize24Glyph.displayName = 'MaxSquareBrandSize24Glyph';
